/**
 * Escopo do LAYOUT e da configuração de sinal no `localStorage`.
 *
 * É uma constante, e isso é decisão de produto: **o painel é do turno, não da
 * pessoa.** Quem monta o painel monta para quem vier depois; dois operadores no
 * mesmo equipamento precisam ver a mesma coisa, senão a passagem de turno vira
 * uma discussão sobre qual tela está certa.
 *
 * JÁ FOI o id do usuário logado, por um dia, e o estrago ensinou o motivo:
 * escopar por pessoa criou DOIS layouts paralelos no mesmo navegador. O
 * operador montou o painel sob um escopo, a sessão passou a valer, o painel
 * começou a ler o outro escopo — vazio — e caiu para o layout do servidor. Do
 * lado de quem usa, "o painel perdeu tudo o que eu configurei", sem nenhuma
 * ação que explicasse.
 *
 * O erro de fundo foi escopar em UM lado só: o `localStorage` passou a ser por
 * usuário e o layout no servidor continuou compartilhado. Estado com duas
 * chaves diferentes para a mesma coisa sempre acaba assim.
 *
 * O que É pessoal tem lugar próprio e fica no servidor: a janela do gráfico, em
 * `user_preferences`, e o layout, em `dashboard_layout_settings.user_id` — os
 * dois resolvidos pela SESSÃO, que o navegador não precisa saber.
 *
 * É uma constante e não uma função: houve aqui um `useCurrentUserId()` que não
 * lia contexto nenhum e existia só para parecer um hook. O nome prometia um
 * valor que muda com quem está logado — exatamente o contrário do que este
 * módulo garante — e convidava a próxima pessoa a "só" ligá-lo à sessão, que é
 * o estrago descrito acima.
 */
export const DEFAULT_OPERATOR_USER_ID = "operator-local";
